var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryEs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_8590)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_8590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_8590)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.33333H28V0H0V5.33333Z",
    fill: "#DD172C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H28V14.6666H0V20Z",
    fill: "#DD172C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.6667H28V5.33337H0V14.6667Z",
    fill: "#FFD133"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33325 9.33333H8.66659V10H7.33325V9.33333Z",
    fill: "#FFEDB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0591 9.36098C6.0429 9.16663 6.19627 8.99996 6.39128 8.99996H8.27555C8.47056 8.99996 8.62393 9.16663 8.60773 9.36097L8.43645 11.4163C8.39326 11.9346 7.95999 12.3333 7.4399 12.3333H7.22693C6.70684 12.3333 6.27357 11.9346 6.23038 11.4163L6.0591 9.36098Z",
    stroke: "#A41517",
    strokeWidth: 0.666667
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 10H8.66667V10.6667H8L7.33333 12L6.66667 10.6667H6V10Z",
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8.66667C4 8.29848 4.29848 8 4.66667 8C5.03486 8 5.33333 8.29848 5.33333 8.66667V12C5.33333 12.3682 5.03486 12.6667 4.66667 12.6667C4.29848 12.6667 4 12.3682 4 12V8.66667Z",
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 8.66667C9.33325 8.29848 9.63173 8 9.99992 8C10.3681 8 10.6666 8.29848 10.6666 8.66667V12C10.6666 12.3682 10.3681 12.6667 9.99992 12.6667C9.63173 12.6667 9.33325 12.3682 9.33325 12V8.66667Z",
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7.33329C6 6.9651 6.29848 6.66663 6.66667 6.66663H8C8.36819 6.66663 8.66667 6.9651 8.66667 7.33329C8.66667 7.70148 8.36819 7.99996 8 7.99996H6.66667C6.29848 7.99996 6 7.70148 6 7.33329Z",
    fill: "#A41517"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_8590"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryEs);
export default __webpack_public_path__ + "static/media/Country=ES.68e03022f4ce139482b2686196676234.svg";
export { ForwardRef as ReactComponent };